import { render, staticRenderFns } from "./ElectrodeFixOne.vue?vue&type=template&id=066b24be&scoped=true"
import script from "./ElectrodeFixOne.vue?vue&type=script&lang=js"
export * from "./ElectrodeFixOne.vue?vue&type=script&lang=js"
import style0 from "./ElectrodeFixOne.vue?vue&type=style&index=0&id=066b24be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066b24be",
  null
  
)

export default component.exports